export const mockUUID = 'bfb1dd60-60ae-11ea-ae34-7f94f67daa5f'
